/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationNeedsMutation($input: SaveSimulationNeeds_M_simulation_needsInput!) {
    saveSimulationNeeds_M_simulation_needs(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
